// Todo: fix isBusy
import { PAGE_ENTER_DEFAULT_STYLE, PAGE_EXIT_DEFAULT_STYLE, PAGE_EXIT_DEFAULT_UP_STYLE, PAGE_STYLE } from '../page'
import router, { IRouteParams } from '../../../base/lib/router'
import { Base } from '../../../base/components/base'
import ldb from '../../../base/lib/ldb'
import { Div } from '../../../base/components/native/div'
import { waitFor } from '../../../base/utils/wait'

export const MenuPage = () => {
    const base = Base()
    const l1 = Div('به روزرسانی نرخ‌ها')
    const l2 = Div('به روزرسانی امتیاز')
    const contents = Div()
    contents.append(l1, l2)
    const header = Div('منوی اصلی')
    l1.el.onclick = () => router.goto('/')
    l2.el.onclick = () => router.goto('/cashback')
    // const tweak = Tweak()

    base.cssClass({ ...PAGE_STYLE, direction: 'rtl', padding: '20px 60px' })
    base.append(header, contents)

    header.cssClass({
        fontSize: '20px',
        marginBottom: '20px',
    })
    l1.cssClass({
        fontSize: '16px',
        marginBottom: '20px',
        cursor: 'pointer',
    })
    l2.cssClass({
        fontSize: '16px',
        marginBottom: '20px',
        cursor: 'pointer',
    })
    return Object.assign(base, {
        async enter() {
            if (!ldb.get('DANESH_FX_ADMIN_TOKEN')) {
                setTimeout(() => {
                    router.goto('/login')
                }, 500)
            }
            await waitFor(200)
            base.style(PAGE_ENTER_DEFAULT_STYLE)
        },
        exit({ to }: IRouteParams) {
            base.style(PAGE_EXIT_DEFAULT_STYLE)
            if (to === '/cashback') base.style(PAGE_EXIT_DEFAULT_UP_STYLE)
        }
    })
}